import React, { useContext, useState } from 'react';
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { PageContext } from '../Context/PageProvider'


function FilterBar({ t }) {
    const context = useContext(PageContext)
    const [filters, setFilters] = useState({ messageType: "", target: "", language: "" })

    const handleChange = async (key, value) => {
        setFilters(prevState => ({ ...prevState, [key]: value }))
        await context.setMessageFilters({ ...filters, [key]: value })
    }

    const classes = useStyles()

    return (
        <Container className={classes.root} maxWidth="xl">
            <Container maxWidth="md">
                <Grid container>
                    <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink> {t('message_type')} </InputLabel>
                            <Select value={filters.messageType} onChange={(e) => handleChange('messageType', e.target.value)} displayEmpty >
                                <MenuItem value={""}>{t("all")}</MenuItem>
                                <MenuItem value={'alert'}>{t("alert")}</MenuItem>
                                <MenuItem value={'message'}>{t("message")}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink> {t('target')} </InputLabel>
                            <Select value={filters.target} onChange={(e) => handleChange('target', e.target.value)} displayEmpty >
                                <MenuItem value={""}>{t('all')}</MenuItem>
                                <MenuItem value={'customer'}>{t('guest')}</MenuItem>
                                <MenuItem value={'trainer'}>{t('trainer')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink> {t('language')} </InputLabel>
                            <Select value={filters.language} onChange={(e) => handleChange('language', e.target.value)} displayEmpty >
                                <MenuItem value={""}>{t('all')}</MenuItem>
                                <MenuItem value={'de'}>{t('german')}</MenuItem>
                                <MenuItem value={'en'}>{t('english')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.primary.canvas
    },
    formControl: {
        paddingRight: theme.padding.small,
        marginTop: theme.margin.small,
        marginBottom: theme.margin.small,
        minWidth: 120,
    }
}))

export default withTranslation()(withRouter(FilterBar))